import { closeDialog, openLocationDashboard, submitForm } from '../../actions';
import { ActionsSection, RowItemType, SectionType, UIElementType, UIItem } from '../../models';
import { DialogActionsFieldId } from '../common.models';
import { ButtonDisableIdentifier } from '../../models/validator-identifier';
import { FlexSectionIds } from './base-config-models';
import { FlexLocationCardState } from './models';
import { FlexCreateMode } from '../../reducers';

const SAVE_CANCEL_ROW_ID = 'save-cancel-row';

const actionsMenu: UIItem = {
    id: 'moreOptionsMenu',
    type: RowItemType.UI,
    uiType: UIElementType.Menu,
    name: 'moreOptionsMenu',
    iconName: 'arrow_drop_down',
    disabledSelector: ButtonDisableIdentifier.invalidOrPristine,
    panelClass: 'pl-2 menu-button',
    menuConfig: {
        label: '',
        items: [
            {
                id: 'saveMenuItem',
                type: RowItemType.UI,
                uiType: UIElementType.Button,
                name: 'saveButton',
                label: 'COMMON.SAVE_BUTTON',
                disabledSelector: ButtonDisableIdentifier.invalidOrPristine,
                panelClass: 'mat-button',
                events: {
                    onClick: () => [submitForm({ shouldClose: false, isActivationRequired: false })],
                },
            },
        ],
    },
};

const verticalDivider: UIItem = {
    id: 'verticalDivider',
    type: RowItemType.UI,
    uiType: UIElementType.Divider,
    name: 'verticalDivider',
    dividerStyle: 'solid',
    dividerThickness: 1,
    disabledSelector: ButtonDisableIdentifier.invalidOrPristine,
    dividerColor: '#e0e0e0',
    panelClass: 'divider-vertical',
};

export const dialogActions = (state: FlexLocationCardState): ActionsSection => {
    const { locationCardData, metadata } = state;
    const { editMode } = locationCardData;

    const flexMode = metadata?.flexCreateMode || FlexCreateMode.init;

    const dialogActionsSection: ActionsSection = {
        info: {
            id: FlexSectionIds.DialogActions,
            title: '',
            type: SectionType.Actions,
            displayTitle: false,
            expandable: false,
            expanded: true,
            panelClass: 'dialog-actions-container',
        },
        rows: [
            // Left side buttons row
            {
                info: {
                    id: 'pre-edit-controls-row',
                    panelClass: 'pre-edit-controls',
                },
                items: [
                    {
                        id: DialogActionsFieldId.LocationDashboardButton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        visible: editMode && state.fromHomeDashboard,
                        name: 'locationDashboardButton',
                        tooltip: 'HOME.MAP.LOCATION_DASHBOARD_TOOLTIP',
                        disabledSelector: ButtonDisableIdentifier.invalidOrUnsaved,
                        iconName: 'show_chart',
                        panelClass: 'auto-margin  allow-disabled-tooltip',
                        events: {
                            onClick: () => [openLocationDashboard()],
                        },
                    },
                ],
            },
            {
                info: {
                    id: SAVE_CANCEL_ROW_ID,
                    panelClass: editMode ? '' : 'mr-3',
                },
                items: [
                    {
                        id: DialogActionsFieldId.CancelButton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'cancelButton',
                        label: editMode && flexMode === FlexCreateMode.success ? 'COMMON.CLOSE' : 'COMMON.CANCEL',
                        panelClass: 'mat-button',
                        events: {
                            onClick: () => [closeDialog()],
                        },
                    },
                    {
                        id: DialogActionsFieldId.SaveButton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'saveButton',
                        label: editMode ? 'COMMON.SAVE_CLOSE_BUTTON' : 'COMMON.SAVE',
                        disabledSelector: ButtonDisableIdentifier.invalidOrPristine,
                        panelClass: 'mat-button pr-0',
                        events: {
                            onClick: () => [submitForm({ shouldClose: true, isActivationRequired: false })],
                        },
                    },
                ],
            },
        ],
    };

    if (editMode) {
        dialogActionsSection.rows
            .find((v) => v.info.id === SAVE_CANCEL_ROW_ID)
            ?.items.push(verticalDivider, actionsMenu);
    }

    return dialogActionsSection;
};
